const MovementsTooltipStyles = (theme) => {
  return {
    movementTooltip: {
      width: 300,
        minWidth: 300,
          maxWidth: 300,
    }, 
    movementTooltipMedium: {
      width: 350,
        minWidth: 350,
          maxWidth: 350,
    }, 
    movementTooltipLarge: {
      width: 400,
        minWidth: 400,
          maxWidth: 400,
    }, 
    timeBlock: {
      textAlign: "center"
    },
    header: {
      fontSize: 12,
      fontWeight: 1000,
      paddingBottom: 5
    },
    date: {
      fontSize: 10,
      fontWeight: 1000
    },
    time: {
      fontSize: 12,
      fontWeight: 1000
    },
  }
}
export default MovementsTooltipStyles;